function buildPieChartLegendLabels() {
  return {
    color: '#5E5E52',
    padding: 16,
    usePointStyle: true,
    pointStyleWidth: 8,
    boxWidth: 8,
    boxHeight: 8,
    font: { size: 12, weight: '500' },
    generateLabels: (chart) => {
      const data = chart.data;

      return data.labels.map((label, index) => ({
        text: label,
        fillStyle: data.datasets[0].backgroundColor[index],
        strokeStyle: data.datasets[0].backgroundColor[index],
        lineWidth: 0,
        hidden: false,
        index,
        pointStyle: 'circle',
      }));
    }
  };
}

function buildPieChartLegendItems(labels, colors) {
  return labels.map((label, index) => ({
    index,
    label,
    color: colors[index]
  }));
}

function renderPieChartLegend(container, chart, items) {
  container.replaceChildren();

  const list = container.ownerDocument.createElement('ul');
  list.className = 'df-chart-legend-list';

  items.forEach((item) => {
    const listItem = container.ownerDocument.createElement('li');
    const button = container.ownerDocument.createElement('button');
    const marker = container.ownerDocument.createElement('span');
    const label = container.ownerDocument.createElement('span');

    button.type = 'button';
    button.className = 'df-chart-legend-item';
    button.setAttribute('aria-pressed', 'true');
    button.setAttribute('aria-label', `Afficher ou masquer ${item.label}`);

    marker.className = 'df-chart-legend-marker';
    marker.style.backgroundColor = item.color;
    marker.setAttribute('aria-hidden', 'true');

    label.className = 'df-chart-legend-label';
    label.textContent = item.label;

    button.append(marker, label);
    button.addEventListener('click', () => {
      chart.toggleDataVisibility(item.index);
      chart.update();

      const visible = chart.getDataVisibility(item.index);
      button.classList.toggle('is-muted', !visible);
      button.setAttribute('aria-pressed', visible.toString());
    });

    listItem.append(button);
    list.append(listItem);
  });

  container.append(list);
}

module.exports = buildPieChartLegendLabels;
module.exports.buildPieChartLegendItems = buildPieChartLegendItems;
module.exports.renderPieChartLegend = renderPieChartLegend;
